import LegalPage from "@/components/legal/LegalPage";

const H2 = {
  color: '#f7f7f7',
  fontSize: 18,
  fontWeight: 700,
  marginTop: 24,
  marginBottom: 10,
  letterSpacing: '0.2px'
};

const H3 = {
  color: '#f7f7f7',
  fontSize: 15,
  fontWeight: 700,
  marginTop: 20,
  marginBottom: 8,
  letterSpacing: '0.2px'
};

const A = {
  color: '#C9A86A',
  textDecoration: 'underline'
};

export default function Faq() {
  return (
    <LegalPage title="FAQ" testid="page-faq">
      <>
        <h2 style={H2}>1. What is a Collection?</h2>
        <p>A Collection is a top level group (Wine, Whisky, Spirits) that holds your categories and items.</p>

        <h2 style={H2}>Do I need to set my currency and tax rate?</h2>
        <p>Yes. To ensure accurate pricing, tax handling, and valuations, you must set your preferred currency and your country{"\u2019"}s tax rate in <strong>Settings</strong> before adding collections. The app uses your tax rate to convert between EX and INC pricing and to calculate totals correctly.</p>

        <h2 style={H2}>2. How do I create a Collection?</h2>
        <p>Go to Collections → Create Collection, choose Wine, Whisky, or Spirits.</p>
        <p>Trial: 1 per type.</p>
        <p>Basic: Unlimited collections using the available collection types.</p>

        <h2 style={H2}>3. Can I edit or delete a Collection?</h2>
        <p>Yes. You can rename or delete a collection. Deleting a collection removes all categories and items inside it.</p>

        <h2 style={H2}>4. What is a Category?</h2>
        <p>A Category is a grouping inside a collection (e.g., Red Wine, Single Malt). It contains preset fields + any custom fields you add.</p>

        <h2 style={H2}>5. How do I create a Category?</h2>
        <h3 style={H3}>Inside a Collection</h3>
        <p>Category Name is required.</p>
        <p>Whisky: Name → optional Country → optional Distillery → Save</p>
        <p>Wine: Name → optional Country → optional Region → Save</p>
        <p>Spirits: Name → optional Country → optional Producer/Distillery → Save</p>
        <p>To add custom fields: open the category → Edit Category.</p>

        <h3 style={H3}>From the Categories Page</h3>
        <p>Go to Categories → Create a new category: Name → choose Collection → optional Description → optional Custom Fields → Save.</p>

        <h3 style={H3}>Preset vs Custom Fields</h3>
        <p><strong>Preset fields</strong></p>
        <p>Applied automatically based on collection type. Cannot be edited or deleted. Always appear at the top of each item.</p>
        <p><strong>Custom fields</strong></p>
        <p>You can add them during category creation (Categories page) or after saving (inside a collection).</p>
        <p>They appear below preset fields and can be edited, reordered, or removed.</p>

        <h2 style={H2}>6. Can I edit or delete a Category?</h2>
        <p>Yes. Renaming is allowed. Deleting a category does not delete items — they move to Uncategorised.</p>

        <h2 style={H2}>7. What is an Item?</h2>
        <p>An Item is a single bottle/collectable with photos, notes, preset fields, and any custom fields from its category.</p>

        <h2 style={H2}>8. How do I create an Item?</h2>
        <p>You can add an item from:</p>
        <p>• Inside a Collection</p>
        <p>• Items tab</p>
        <p>• When creating a Collection</p>
        <p>• Via Categories (jump into the collection → Add Item)</p>
        <p>Trial = 12 items total. Basic = unlimited.</p>

        <h2 style={H2}>9. Can I edit or delete an Item?</h2>
        <p>Yes. You can update details or delete the item anytime.</p>

        <h2 style={H2}>10. How does the Dashboard work?</h2>
        <p>Dashboard shows analytics for one collection: totals, value, maturity, categories, regions, grapes, performance, and composition.</p>

        <h2 style={H2}>11. What is Portfolio Analytics?</h2>
        <p>Portfolio Analytics shows financial performance across all collections: total cost, value, profit, category breakdown, collection comparison, and sales history.</p>

        <h2 style={H2}>12. Dashboard vs Portfolio Analytics</h2>
        <p>Dashboard = one collection.</p>
        <p>Portfolio Analytics = everything.</p>

        <h2 style={H2}>13. How do I upload photos?</h2>
        <p>Items: up to 3 photos.</p>
        <p>Categories: 1 photo (via Categories → Edit).</p>

        <h2 style={H2}>14. How does the trial work?</h2>
        <p>3 Days (72 hours), 1 collection per type, 12 items, all Basic features except unlimited items/collections.</p>

        <h2 style={H2}>15. How do I upgrade to Basic?</h2>
        <p>Go to Plan & Pricing → Purchase Basic or click Upgrade to Basic in the header.</p>

        <h2 style={H2}>16. What happens after I upgrade?</h2>
        <p>You can create unlimited collections based on the 3 collection types and unlimited items for Basic Plan, and all other Basic Features.</p>

        <h2 style={H2}>17. How do I change my password?</h2>
        <p>Go to My Account → Change Password.</p>

        <h2 style={H2}>18. Is my data backed up?</h2>
        <p>Yes — all data is securely stored in the cloud.</p>

        <h2 style={H2}>19. Can I export or import my data?</h2>
        <p>Not available for Trial or Basic users.</p>

        <h2 style={H2}>20. Who can I contact for support?</h2>
        <p><a href="mailto:support@cdicollectables.co.nz" style={A}>support@cdicollectables.co.nz</a></p>
      </>
    </LegalPage>
  );
}
